import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  ConstructionTypes, ExtendedProperties,
  IContact, LeadComposerChangesModel,
  LeadData, LeadsDataAction, LeadsHistory,
} from '../../../../models/leads/leads.model';
import { MatDialog } from '@angular/material/dialog';
import { ActionHelper } from '../../../../helper/action.helper';
import { UserTokenService } from '../../../../services/user-service/user-token.service';

@Component({
  selector: 'fi-contact-order-card',
  templateUrl: './contact-order-card.component.html',
  styleUrls: ['./contact-order-card.component.scss'],
  standalone: false,
})
export class ContactOrderCardComponent {

  @Input() selectedLeadDetails: LeadData | undefined;
  @Input() mainOffer: LeadComposerChangesModel;
  @Input() mainOrder: LeadComposerChangesModel;
  @Input() contactToDisplay: IContact;
  @Input() constructionTypes: ConstructionTypes[] = [];
  @Input() selectedLeadHistory: LeadsHistory[];
  @Input() userId: number;
  @Input() offerAmountCount: number;
  @Input() orderAmountCount: number;
  @Input() selectedLeadId: number;
  @Input() extendedProperties: ExtendedProperties;
  @Input() loadedLeadComposerOffers: LeadComposerChangesModel[] = [];


  @Output() editOfferOrderActionRequested = new EventEmitter<any>();
  @Output() editOfferOrderConstructionTypeIdUpdated = new EventEmitter<number>();
  @Output() editOfferOrderLoadComposerOffersRequested = new EventEmitter<any>();
  @Output() leadUpdated = new EventEmitter<number>();

  constructor(
    private userTokenService: UserTokenService,
    private dialog: MatDialog,
  ) {

  }

  onOfferOrderEdit(): void {

    const history = this.selectedLeadHistory;

    if ( !history ) {
      return;
    }

    const actions = [
      this.selectedLeadDetails?.SuggestedAction,
      ...(this.selectedLeadDetails?.Actions ?? [])
    ].filter(x => x && !history.some(h => h && h.ActionName === x.Name));

    ActionHelper.openEditOfferOrder(this.dialog, {
      extendedProperties: this.extendedProperties,
      loadedLeadComposerOffers: this.loadedLeadComposerOffers,
      leadId: this.selectedLeadId,
      isMyLead: this.toggleFileBox(),
      constructionTypeId: this.selectedLeadDetails?.Lead?.ConstructionTypeId,
      mainOffer: this.mainOffer,
      mainOrder: this.mainOrder,
      selectedLeadHistory: this.selectedLeadHistory,
      orderAmountCount: this.orderAmountCount,
      limitedAccess: this.selectedLeadDetails?.Lead?.LimitedAccess,
      isClosed: this.selectedLeadDetails?.Lead?.Done,
      constructionTypes: this.constructionTypes,
      actions,

      onAction: ( name, label, successCallback ) => {
        const action: LeadsDataAction = [this.selectedLeadDetails?.SuggestedAction, ...(this.selectedLeadDetails?.Actions ?? [])]
          .find(x => x?.Name === name) ?? { Id: -1, Name: name, Label: label, };

        this.editOfferOrderActionRequested.emit({ action: action, successCallback: successCallback });
      },

      updateConstructionTypeId: ( $event ) => {
        this.editOfferOrderConstructionTypeIdUpdated.emit($event);
      },

      loadComposerOffers: ( $event, placeOrder, load1, load2 ) => {
        this.editOfferOrderLoadComposerOffersRequested.emit({ event: $event, placeOrder: placeOrder, load1: load1, load2: load2 });
      },
    })
  }


  private toggleFileBox(): boolean {
    const id = this.userTokenService.getId();

    return this.selectedLeadDetails?.Lead?.EditorId === id;
  }

}
